import { BaseApiError } from './BaseApiError';

/**
 * Raised when a network error happens when attempting to make an API call.
 */
export class NetworkError extends BaseApiError {}
